module.exports = __webpack_public_path__ + "static/media/unicef.1c5e46ee.png";